(function () {
  var bannerSelector = '[data-ohli-deferred-banner]';

  function bannersWithin(root) {
    var banners = [];
    if (root.matches && root.matches(bannerSelector)) banners.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(bannerSelector).forEach(function (banner) {
        banners.push(banner);
      });
    }
    return banners;
  }

  function materializeBanner(banner) {
    if (!banner || banner.dataset.ohliDeferredLoaded === 'true') return;

    banner.querySelectorAll('source[data-srcset]').forEach(function (source) {
      source.setAttribute('srcset', source.dataset.srcset);
      source.removeAttribute('data-srcset');
    });

    var images = banner.matches('img') ? [banner] : Array.from(banner.querySelectorAll('img'));
    images.forEach(function (image) {
      var srcset = image.dataset.srcset;
      var src = image.dataset.src;
      image.loading = 'eager';
      if (srcset) image.setAttribute('srcset', srcset);
      if (src) image.setAttribute('src', src);
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
    });

    banner.dataset.ohliDeferredLoaded = 'true';
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              materializeBanner(entry.target);
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '1000px 0px' }
        )
      : null;

  function initialize(root) {
    if (!root) return;
    var designMode = Boolean(window.Shopify && window.Shopify.designMode);

    bannersWithin(root).forEach(function (banner) {
      if (banner.dataset.ohliDeferredObserved === 'true') return;
      banner.dataset.ohliDeferredObserved = 'true';
      banner.removeAttribute('hidden');
      if (designMode || !observer) materializeBanner(banner);
      else observer.observe(banner);
    });
  }

  function unload(event) {
    if (!observer) return;
    bannersWithin(event.target).forEach(function (banner) {
      observer.unobserve(banner);
    });
  }

  initialize(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  document.addEventListener('shopify:section:unload', unload);
})();
